import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../../services/global/global.service';
import { TitleService } from '../../../services/forms/app-title-service';
import { MenuBarService } from './menu-bar.service';
import { SettingsProvider } from '../../../services/global/settings-provider.service';
import { Router } from '@angular/router';
import { AzureAwsSwitchService } from '../../../authentication/azure-aws-switch.service';

@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.css'],
    providers: [TitleService, MenuBarService],
})
export class MenuBarComponent implements OnInit {

    @Input() title: string = 'Data Management Application';
    appName: string;
    error;
    public settings: SettingsProvider;
    public userProfilePic;

    userData: Array<any>;
    settingData: Array<any>;

    constructor(public globals: GlobalService,
//        private titleService: TitleService,
        private azureAws: AzureAwsSwitchService,
        private settingsProvider: SettingsProvider,
        private router: Router,
        private menuBarService: MenuBarService) {
        this.settings = settingsProvider;
    }

    ngOnInit() {
        this.menuBarService.getManifest()
			.subscribe(
				(data => { 
					this.appName = data.name; // [0]; //NB:!! .name;
					// this.globals.loading = false;
				}), // success path
				error => {
					this.error = error // error path
					console.log('Error Fetching Manifest');
					console.log(this.error);
					// this.globals.loading = false;
				}
            );
         // Get users profile pic
        this.azureAws.getLoggedInUserProfilePhoto().subscribe(
            (photo) => {
                let urlCreator = window.URL || window.webkitURL;
                this.userProfilePic = urlCreator.createObjectURL(photo);
            },
            (err) => {
                console.log(err);
                this.userProfilePic = null;
            }
        );
    }

    //******************************************************* */
    // Kendo dialogs
    //******************************************************* */
    public dialogOpenedUser: boolean = false;
    public dialogOpenedInfo: boolean = false;

    public dialogUser(status) {
        if (status == "open") {
            this.dialogOpenedUser = true;
        } else {
            this.dialogOpenedUser = false;
        }
    }

    public dialogInfo(status) {
        if (status == "open") {
            this.dialogOpenedInfo = true;
        } else {
            this.dialogOpenedInfo = false;
        }
    }
    //******************************************************* */

    public logOut() {
        this.router.navigate(['logout']);
    }

}
